// bff平台配置虚位以待-默认头像处理
export const pickRankItemAvatarUrl = (item: any): string => {
  const nested = item?.user?.avatar_url
  if (nested != null && String(nested).trim()) {
    return String(nested).trim()
  }

  const flat = item?.avatar_url
  if (flat != null && String(flat).trim()) {
    return String(flat).trim()
  }

  return ''
}
